import type { BillingUnit } from '@smart-link/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Button } from './ui/button';
import { Label } from './ui/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

export function BillingUnitSelect({
  value,
  onChange,
  id = 'billing-unit',
}: {
  value: string | null;
  onChange: (value: string | null) => void;
  id?: string;
}) {
  const units = useQuery({
    queryKey: ['billing-units'],
    queryFn: () => api<{ rows: BillingUnit[] }>('/api/billing/units'),
  });
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-muted-foreground text-xs">
        客户
      </Label>
      <Select
        value={value ?? '__none__'}
        onValueChange={(next) => onChange(next === '__none__' ? null : next)}
        disabled={units.isPending || units.isError}
      >
        <SelectTrigger id={id} className="w-full">
          <SelectValue placeholder={units.isPending ? '加载中…' : '选择客户'} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value="__none__">未绑定</SelectItem>
            {units.data?.rows.map((unit) => (
              <SelectItem key={unit.id} value={unit.id}>
                {unit.name}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      {units.isError ? (
        <div className="text-destructive flex items-center gap-2 text-xs">
          加载失败
          <Button variant="link" size="sm" onClick={() => units.refetch()}>
            重试
          </Button>
        </div>
      ) : null}
    </div>
  );
}
